import React from "react";
import { EntryTypeInput, EntryTypeInputValue } from "guestlist/EntryTypeInput";
import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import { RenderEditOptions } from "components/MainSectionTemplate/types";
import RequiredNumberInput from "components/ValidatedFields/RequiredNumberInput";

interface AccessTypeFormState {
  quantity: number;
  entryType: EntryTypeInputValue;
}

interface Props {
  list: server.dto.GuestlistList;
}

export const AccessTypeSidePanelDetails = (props: Props) => {
  const [formState, setFormState] = React.useState<AccessTypeFormState>({
    quantity: props.list.quantity,
    entryType: {
      entryType: serverReference.guestlistEntryTypes.find(et => et.value === props.list.entryType),
      customLabel: props.list.entryTypeCustomName,
    }
  });

  const onValueChanged = (key: string, value: any) => {
    if (key === "quantity") {
      setFormState((prevState) => ({
        ...prevState,
        quantity: value,
      }));
    } else if (key === "entryType") {
      setFormState((prevState) => ({
        ...prevState,
        entryType: value,
      }));
    }
  }

  const getUpdateInstruction = (state: AccessTypeFormState): server.dto.UpdateGuestlistAccessTypeInstruction => ({
    guestlistAccessTypeId: props.list.guestlistAccessTypeId,
    quantity: state.quantity,
    entryType: state.entryType.entryType.value,
    entryTypeCustomName: state.entryType.customLabel,
  });

  return <SidePanelDetailSectionTemplate
    isInPageEditable
    onValueChanged={onValueChanged}
    fields={[{
      key: "settings",
      type: "regular",
      title: RESX.Guestlist.List,
      fields: [{
        key: "entryType",
        label: RESX.GeneralLabels.Type,
        render: () => <>{formState.entryType.entryType.value === "customName" ? formState.entryType.customLabel : formState.entryType.entryType.text}</>,
        inPageEdit: {
          render: ({ value, onChange, submit, cancel }: RenderEditOptions<EntryTypeInputValue>) => <EntryTypeInput
            value={value}
            focusOnMount
            validatorKey="entryType"
            onChange={(v, save) => onChange(v, save)}
            cancel={cancel}
            submit={submit}
          />,
          fullWidth: true,
          type: "custom",
          initialValue: formState.entryType,
          submitChange: (value: EntryTypeInputValue) => window.CoreApi.Guestlist.UpdateGuestlistAccessType(
            getUpdateInstruction({
              ...formState,
              entryType: value,
            }),
          ),
        }
      }, {
        key: "quantity",
        label: RESX.GeneralLabels.Available,
        render: () => <span>{`${formState.quantity} PAX`}</span>,
        inPageEdit: {
          render: ({ value, onChange, cancel }) => <RequiredNumberInput
            autoFocus
            width={75}
            validatorKey="pax"
            value={value}
            onChange={(v: number) => onChange(v)}
            onEnterPressed={(v: number) => onChange(v, true)}
            onEscPressed={() => cancel()}
            labelContent="PAX"
            canBeNegative={false}
            canBeEmpty={false}
            decimalPoints={0}
            maxValue={999}
          />,
          fullWidth: true,
          type: "custom",
          initialValue: formState.quantity,
          submitChange: (quantity: number) => window.CoreApi.Guestlist.UpdateGuestlistAccessType({
            ...getUpdateInstruction({ ...formState, quantity: quantity }),
          }),
        },
      }]
    }]}
  />
}